import { Box, Card, CardContent, Grid2, Typography } from "@mui/material";

const RealTimeViewer = ({
	delayPercent,
	productionPercent,
	gapPercent,
}: {
	delayPercent?: number;
	productionPercent?: number;
	gapPercent?: number;
}) => {
	return (
		<>
			<Card
				sx={{
					width: 250,
					height: 110,
				}}
				elevation={1}
			>
				<CardContent>
					<Grid2 container direction="column">
						<Grid2
							container
							justifyContent="space-between"
							sx={{
								marginBottom: (theme) => theme.spacing(1),
							}}
						>
							<Box display="flex" alignItems="center">
								<Box
									width={8}
									height={8}
									borderRadius="50%"
									bgcolor="#2196F3"
									marginRight={1}
								/>
								<Typography
									fontWeight={"bold"}
									sx={{
										userSelect: "none",
									}}
								>
									Production
								</Typography>
							</Box>
							<Typography>
								{productionPercent != null
									? `${parseFloat(productionPercent.toFixed(2))}%`
									: "-"}
							</Typography>
						</Grid2>
						<Grid2
							container
							justifyContent="space-between"
							sx={{
								marginBottom: (theme) => theme.spacing(1),
							}}
						>
							<Box display="flex" alignItems="center">
								<Box
									width={8}
									height={8}
									borderRadius="50%"
									bgcolor="#ff4d4f"
									marginRight={1}
								/>
								<Typography
									fontWeight={"bold"}
									sx={{
										userSelect: "none",
									}}
								>
									Delays
								</Typography>
							</Box>
							<Typography>
								{delayPercent != null
									? `${parseFloat(delayPercent.toFixed(2))}%`
									: "-"}
							</Typography>
						</Grid2>
						<Grid2
							container
							justifyContent="space-between"
							sx={{
								marginBottom: (theme) => theme.spacing(1),
							}}
						>
							<Box display="flex" alignItems="center">
								<Box
									width={8}
									height={8}
									borderRadius="50%"
									bgcolor="#9E9E9E"
									marginRight={1}
								/>
								<Typography
									fontWeight={"bold"}
									sx={{
										userSelect: "none",
									}}
								>
									Gap Time
								</Typography>
							</Box>
							<Typography>
								{gapPercent != null
									? `${parseFloat(gapPercent.toFixed(2))}%`
									: "-"}
							</Typography>
						</Grid2>
					</Grid2>
				</CardContent>
			</Card>
		</>
	);
};

export default RealTimeViewer;
